(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["ThankYouPageViewerWidget"] = factory(require("react"), require("lodash"));
	else
		root["ThankYouPageViewerWidget"] = factory(root["React"], root["_"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__27762__, __WEBPACK_EXTERNAL_MODULE__17607__) => {
return 